import ShoppingFaqContentMaster from "@tw/product-discovery-merchandizing-cra/lib/shopping-faqs/details/shoppingFaqContent-master-nextjs.js";
import PageWrapper from "../wrappers/page-wrapper";

ShoppingFaqContentMaster.domainName = "product-discovery";

export default PageWrapper(ShoppingFaqContentMaster);
